export default "__VITE_ASSET__BFOcKYdj__"